import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { OverviewPage } from './components/OverviewPage';
import { WardOverview } from './components/WardOverview/WardOverview';
import { RightDrawer } from './components/RightDrawer';
import { PlatoView } from "./components/PlatoView/PlatoView";
import { DavinciView } from "./components/DavinciView/DavinciView"; 
//import OpponentViewer from './components/OpponentViewer';
// import InvadersGame from './components/InvadersGame'; // REMOVED: Game functionality removed
import VoterArchetype from './components/VoterArchertype';
import DemographicsSuite from './components/Demographics'; // IMPORT PATH FIXED
import CandidateViewer from "./components/CandidateViewer/CandidateViewer";
import CampaignMap from './components/CampaignMap';
import LocalIssuePortal from './components/LocalIssuesPortal'; 
import DanteChatBot from './components/DanteChatBot';
import ImageGallery from './components/imageGallery';
import CampaignGallery from './components/CampaignGallery';
import SimCalendar from './components/SimCalender'; 
import SettingsPage from './components/UserSettings'; 
import NotificationsPage from './components/SystemComponents/Notifications';
import { Search, Settings, User, Menu, LayoutDashboard, Brain, ChevronRight, ChevronDown, Swords, PieChart, Vote, Map, Users, Bot, RefreshCw, LogOut, AlertCircle, Megaphone, Sparkles, FolderHeart, CheckCircle2, Lock, ChevronsUpDown, Inbox } from 'lucide-react'; 
import logo from "./assets/favicon.png";
import SystemMessageModal from "./components/SystemComponents/SystemMessageModal"

// ====================================================================================
// UPDATED: Party Icon Imports
// ====================================================================================
import libDemLogo from "./assets/party_icons/Libby_Orange.png";
import reformLogo from "./assets/party_icons/Reform_UK_Logo.png";
import labourLogo from "./assets/party_icons/Labour_logo.png";
import greenLogo from "./assets/party_icons/Green_Party_Logo.png";
import toryLogo from "./assets/party_icons/Conservative_Logo.png";

import danteIcon from "./assets/Dante-White-Icon-01.png";
import danteWhiteFull from "./assets/Dante-White-Full-01.png";
import 'maplibre-gl/dist/maplibre-gl.css';
import SignInPage from './components/SignInPage/signInPage';
import { auth, isSignedIn, useAuthUser, db } from './firebase';
import { encryptedFetch as fetch } from './security';
import {collection, doc, getDocs, onSnapshot, setDoc } from 'firebase/firestore'; 
import * as eighteen from "./data/demographics/cohort_summary_18_24.json"
import * as twentyfive from "./data/demographics/cohort_summary_25_34.json"
import * as thirtyfive from "./data/demographics/cohort_summary_35_44.json"
import * as fortyfive from "./data/demographics/cohort_summary_45_54.json"
import * as fiftyfive from "./data/demographics/cohort_summary_55_64.json"
import * as sixtyfour from "./data/demographics/cohort_summary_64_75.json"
import * as seventyfive from "./data/demographics/cohort_summary_75_plus.json"
import { m } from 'framer-motion';
import { signOut } from 'firebase/auth';
import {log, getUsage, getDwellTime} from "./logging"

// ====================================================================================
// CONSTANT: URL MAPPING (Internal View ID -> Public URL Name)
// ====================================================================================
const URL_MAPPING = {
  overview: 'dashboard',
  plato: 'campaign-matrix',
  campaignGallery: 'saved-campaigns',
  simCalendar: 'simulation-calendar',
  opponentViewer: 'opponents',
  voterArchetype: 'electorate-archetypes',
  demographics: 'electorate-demographics',
  candidateViewer: 'candidates',
  campaignMap: 'map',
  localIssues: 'issues',
  davinci: 'vision-strategy',
  gallery: 'image-gallery',
  chatbot: 'dante-ai',
  settings: 'settings',
  ward_overview: 'ward-analysis',
  notifications: 'inbox'
};

// ====================================================================================
// HELPER FUNCTION: Time-Based Greeting 
// ====================================================================================
const getTimeOfDayGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) {
    return 'Good Morning';
  } else if (hour < 18) {
    return 'Good Afternoon';
  } else {
    return 'Good Evening';
  }
};

// ====================================================================================
// HELPER FUNCTION: Get Party Logo
// ====================================================================================
const getPartyLogo = (partyName) => {
  if (!partyName) return libDemLogo; // Default fallback

  const normalized = partyName.toLowerCase();

  // Basic string matching for known parties
  if (normalized.includes('liberal') || normalized.includes('lib dem')) {
    return libDemLogo;
  }
  if (normalized.includes('reform')) {
    return reformLogo;
  }
  if (normalized.includes('labour')) {
    return labourLogo;
  }
  if (normalized.includes('green')) {
    return greenLogo;
  }
  if (normalized.includes('conservative') || normalized.includes('tory')) {
    return toryLogo;
  }

  // Fallback if no match found
  return libDemLogo; 
};

// ====================================================================================
// HELPER COMPONENT: Typing Effect for Loader
// ====================================================================================
const TypingEffect = ({ text, speed = 80 }) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    setDisplayedText(''); // Reset on text change
    let index = 0;
    const timer = setInterval(() => {
      setDisplayedText((prev) => text.slice(0, index + 1));
      index++;
      if (index === text.length) {
        clearInterval(timer);
      }
    }, speed);

    return () => clearInterval(timer);
  }, [text, speed]);

  return (
    <span className="font-grotesk font-medium tracking-wide text-slate-200">
      {displayedText}
      <span className="animate-pulse font-bold text-accent-500 ml-1">_</span>
    </span>
  );
};
// ====================================================================================
// COMPONENT: Sidebar
// ====================================================================================
const Sidebar = ({ 
  isOpen, 
  setIsOpen, 
  isMobileNav = false,
  userFirstName, 
  userFullName, 
  userParty, 
  userEmail, 
  displayCampaignName, 
  timeGreeting, 
  onNavigate, 
  activeView, 
  selectedWard, 
  campaignData,
  availableCampaigns = [], 
  currentCampaignId,       
  onSwitchCampaign         
}) => {
  const [openRegion, setOpenRegion] = useState(null);
  const [openAuthority, setOpenAuthority] = useState(null);
  const [wardQuery, setWardQuery] = useState('');
  
  // DROPDOWN STATES
  const [isVisionOpen, setIsVisionOpen] = useState(false); 
  const [isCampaignsOpen, setIsCampaignsOpen] = useState(false); 
  const [isElectorateOpen, setIsElectorateOpen] = useState(false); 
  
  // NEW: Campaign Selector State
  const [isCampaignSelectorOpen, setIsCampaignSelectorOpen] = useState(false);

  // DETERMINE PARTY LOGO
  const currentPartyLogo = useMemo(() => getPartyLogo(userParty), [userParty]);

  const allWardsFlat = useMemo(() => {
    return Object.entries(campaignData?.wards ?? {}).flatMap(([region, authorities]) =>
      Object.entries(authorities).flatMap(([authority, wards]) =>
        Object.keys(wards).map(wardName => ({
          name: wardName,
          authority,
          region,
        }))
      )
    );
  }, [campaignData]);

  const filteredWards = useMemo(() => {
    if (!wardQuery) return [];
    return allWardsFlat.filter(ward =>
      ward.name.toLowerCase().includes(wardQuery.toLowerCase()) ||
      ward.authority.toLowerCase().includes(wardQuery.toLowerCase())
    );
  }, [wardQuery, allWardsFlat]);

  const handleSearchedWardClick = (ward) => {
    // DEFENSIVE CODE: Check if the data actually exists before using it
    // We use ?. (optional chaining) to safely check every step of the path
    const wardInfo = (campaignData?.wards ?? {})[ward.region]?.[ward.authority]?.[ward.name];
    
    // SAFETY CHECK: If wardInfo is null (e.g. during a campaign switch), STOP.
    if (!wardInfo) {
      console.warn(`Click ignored: Data missing for ward '${ward.name}' (likely switching campaigns)`);
      return;
    }

    const fullWardData = {
      ...wardInfo, 
      // Safe access: ensures we don't crash if 'narratives' is undefined or if 'n' is null
      narrative: campaignData?.narratives?.find(n => n?.ward_id === wardInfo.ward_code)?.narrative ?? null,
      demographic_variants: campaignData?.demographicVariants?.find(d => d?.ward_code === wardInfo.ward_code) ?? null,
    };
    
    onNavigate('ward_overview', fullWardData);
    setOpenRegion(ward.region);
    setOpenAuthority(ward.authority);
    setWardQuery('');
    
    setIsVisionOpen(false); 
    setIsCampaignsOpen(false); 
    setIsElectorateOpen(false);
  };
  
  const handleWardClick = (region, authority, wardName) => {
    // DEFENSIVE CODE: Check if the data actually exists
    const wardInfo = (campaignData?.wards ?? {})[region]?.[authority]?.[wardName];

    // SAFETY CHECK: If wardInfo is null, STOP.
    if (!wardInfo) {
      console.warn(`Click ignored: Data missing for ward '${wardName}' (likely switching campaigns)`);
      return;
    }

    const fullWardData = {
      ...wardInfo, 
      // Safe access: ensures we don't crash if 'narratives' is undefined or if 'n' is null
      narrative: campaignData?.narratives?.find(n => n?.ward_id === wardInfo.ward_code)?.narrative ?? null,
      demographic_variants: campaignData?.demographicVariants?.find(d => d?.ward_code === wardInfo.ward_code) ?? null,
    };
    
    onNavigate('ward_overview', fullWardData);
    
    setIsVisionOpen(false); 
    setIsCampaignsOpen(false); 
    setIsElectorateOpen(false);
  };

  const handleMainNavigation = (view) => {
    onNavigate(view);
    setOpenRegion(null); 
    setOpenAuthority(null);
    setIsVisionOpen(false); 
    setIsCampaignsOpen(false);
    setIsElectorateOpen(false);
    if (isMobileNav) setIsOpen(false);
  }

  const handleSubNavigation = (view) => {
    onNavigate(view);
    setOpenRegion(null);
    setOpenAuthority(null);
    if (isMobileNav) setIsOpen(false);
  }
  
  const getNavClasses = (view) => 
    `w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${!isOpen && 'justify-center'} ${activeView === view ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`;

  return (
    <aside className={`
      shrink-0 bg-slate-900/80 backdrop-blur-md border-r border-slate-700 transition-all duration-300 ease-in-out
      ${isMobileNav
        ? `fixed top-16 left-0 h-[calc(100vh-64px)] z-40 w-72 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`
        : `sticky top-16 h-[calc(100vh-64px)] ${isOpen ? 'w-72' : 'w-20'}`
      }
    `}>
      {/* FIX: Changed from "h-full flex flex-col overflow-y-auto" to separate scroll container.
         This ensures the footer stays fixed at the bottom while only the middle section scrolls.
      */}
      <div className="flex flex-col h-full overflow-hidden">
        
        {/* Header Section (contains greeting and selector) - FIXED */}
        <div className={`flex flex-col p-4 border-b border-slate-800 shrink-0 ${!isOpen && 'items-center justify-center'}`}>
          <div className={`flex items-center w-full ${!isOpen ? 'justify-center' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} className={`p-2 rounded-md text-slate-400 hover:bg-slate-800 flex-shrink-0 ${isOpen ? 'mr-2' : ''}`}>
              <Menu size={20} />
            </button>
            
            {isOpen && (
              <div className="overflow-hidden relative flex-1">
                <div className="text-sm font-bold text-white truncate">{timeGreeting}, {userFirstName}</div>
                
                {/* === FIXED CAMPAIGN SELECTOR TRIGGER === */}
                {availableCampaigns.length > 1 ? (
                   <div className="relative">
                     <button 
                       onClick={() => setIsCampaignSelectorOpen(!isCampaignSelectorOpen)}
                       className="flex items-center w-full text-xs text-slate-400 hover:text-white transition-colors group mt-0.5"
                     >
                       <span className={`truncate flex-1 text-left ${isCampaignSelectorOpen ? 'text-white drop-shadow-[0_0_8px_rgba(255,255,255,0.5)]' : ''}`}>
                          {displayCampaignName}
                       </span>
                       <ChevronsUpDown size={12} className={`ml-1 opacity-70 group-hover:opacity-100 transition-transform duration-200 ${isCampaignSelectorOpen ? 'rotate-180 text-white drop-shadow-[0_0_8px_rgba(255,255,255,0.5)]' : ''}`} />
                     </button>
                   </div>
                 ) : (
                   <div className="text-xs text-slate-400 truncate mt-0.5">{displayCampaignName}</div>
                 )}
              </div>
            )}
          </div>

          {/* === UPDATED CAMPAIGN LIST (AESTHETIC UPGRADE) === */}
          {isOpen && isCampaignSelectorOpen && availableCampaigns.length > 1 && (
            <div className="mt-3 w-full bg-slate-950/40 backdrop-blur-sm border border-slate-700/60 rounded-xl overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.4)] animate-in slide-in-from-top-2 fade-in duration-300 ring-1 ring-white/5">
               <div className="px-3 py-2 text-[10px] uppercase text-slate-500 font-bold tracking-widest border-b border-slate-700/50 bg-slate-900/40">
                 Select Campaign
               </div>
               
               <div className="max-h-56 overflow-y-auto custom-scrollbar p-1.5 space-y-1">
                 {availableCampaigns.map(camp => {
                   const isActive = currentCampaignId === camp.campaignID;
                   return (
                     <button
                       key={camp.campaignID} 
                       onClick={() => {
                         console.hidden("Switching to Campaign:", camp.campaignID); 
                         onSwitchCampaign(camp.campaignID); 
                         setIsCampaignSelectorOpen(false);
                       }}
                       className={`w-full text-left px-3 py-2.5 rounded-lg text-xs transition-all duration-200 flex items-center justify-between group relative overflow-hidden
                          ${isActive 
                              ? 'bg-slate-800/80 text-white shadow-[0_0_15px_rgba(255,255,255,0.07)] border border-slate-600/50' 
                              : 'text-slate-400 hover:bg-slate-800/50 hover:text-slate-200 border border-transparent'
                          }`}
                     >
                       {/* Subtle Glow Background for Active State */}
                       {isActive && <div className="absolute inset-0 bg-gradient-to-r from-white/5 to-transparent pointer-events-none" />}

                       <div className="overflow-hidden mr-2 relative z-10">
                          <span className={`block truncate text-sm ${isActive ? 'font-semibold drop-shadow-[0_0_8px_rgba(255,255,255,0.4)]' : ''}`}>
                              {camp.campaignName} 
                          </span>
                          {/* CHANGED: Using candidateName instead of partyName */}
                          <span className={`text-[10px] block truncate mt-0.5 ${isActive ? 'text-slate-300' : 'text-slate-500 group-hover:text-slate-400'}`}>
                             {camp.candidateName || 'Unknown Candidate'}
                          </span>
                       </div>
                       
                       {/* White Glow Icon */}
                       {isActive && (
                         <CheckCircle2 
                            size={14} 
                            className="text-white flex-shrink-0 drop-shadow-[0_0_8px_rgba(255,255,255,0.8)] relative z-10" 
                         />
                       )}
                     </button>
                   );
                 })}
               </div>
            </div>
          )}
          {/* === END SELECTOR === */}
        </div>

        {/* Scrollable Navigation Section */}
        <div className="flex-1 overflow-y-auto custom-scrollbar">
          <nav className="flex-grow px-2 py-4 space-y-2">
            
            <div>
              <div className={`text-xs uppercase tracking-wider text-slate-500 mb-2 px-3 ${!isOpen && 'text-center'}`}>{isOpen ? 'Navigation' : 'NAV'}</div>
              <div className="space-y-1">
                <button onClick={() => onNavigate('chatbot')} className={getNavClasses('chatbot')}>
                  <img src={danteIcon} alt="Dante Chatbot" className="w-[18px] h-[18px] flex-shrink-0 object-contain" />
                  {isOpen && <span className="flex-1 text-left font-">Ask me anything</span>}
                </button>
                
                <button onClick={() => handleMainNavigation('overview')} className={getNavClasses('overview')}>
                  <LayoutDashboard size={18} />
                  {isOpen && <span className="flex-1 text-left">Overview</span>}
                </button>

                {/* Campaigns Dropdown */}
                {/* Campaigns — with collapsed popout */}
                <div className="relative group/campaigns">
                  <button 
                    onClick={() => {
                      if (!isOpen) { handleSubNavigation('plato'); return; }
                      setIsCampaignsOpen(!isCampaignsOpen);
                      setIsVisionOpen(false); 
                      setIsElectorateOpen(false);
                      setOpenRegion(null); 
                      setOpenAuthority(null);
                    }} 
                    className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${isOpen ? 'justify-between' : 'justify-center'} ${
                      (activeView === 'plato' || activeView === 'campaignGallery' || activeView === 'simCalendar') ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <Brain size={18} />
                      {isOpen && <span className="flex-1 text-left">Campaigns</span>}
                    </div>
                    {isOpen && (isCampaignsOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />)}
                  </button>
                  {/* Collapsed popout */}
                  {!isOpen && (
                    <div className="absolute left-full top-0 ml-2 z-50 hidden group-hover/campaigns:flex flex-col min-w-[160px] bg-slate-800 border border-slate-700 rounded-lg shadow-xl py-1 pointer-events-auto">
                      <div className="px-3 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wider border-b border-slate-700">Campaigns</div>
                      <button onClick={() => handleSubNavigation('plato')} className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-700 ${activeView==='plato'?'text-white':'text-slate-300'}`}>Campaign Matrix</button>
                      <button onClick={() => handleSubNavigation('campaignGallery')} className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-700 ${activeView==='campaignGallery'?'text-white':'text-slate-300'}`}>Simulation Library</button>
                      <button onClick={() => handleSubNavigation('simCalendar')} className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-700 ${activeView==='simCalendar'?'text-white':'text-slate-300'}`}>Simulation Calendar</button>
                    </div>
                  )}
                </div>
                {/* Campaigns Dropdown Menu (expanded) */}
                {isOpen && isCampaignsOpen && (
                  <div className="pl-7 space-y-1 mt-1">
                    <button onClick={() => handleSubNavigation('plato')} className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${activeView === 'plato' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}>
                      <span className="flex-1 text-left">Campaign Matrix</span>
                    </button>
                    <button onClick={() => handleSubNavigation('campaignGallery')} className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${activeView === 'campaignGallery' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}>
                      <span className="flex-1 text-left">Simulation Library</span>
                    </button>
                    <button onClick={() => handleSubNavigation('simCalendar')} className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${activeView === 'simCalendar' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}>
                      <span className="flex-1 text-left">Simulation Calendar</span>
                    </button>
                  </div>
                )}

                {/* ELECTORATE DROPDOWN — with collapsed popout */}
                <div className="relative group/electorate">
                  <button 
                    onClick={() => {
                      if (!isOpen) { handleSubNavigation('voterArchetype'); return; }
                      setIsElectorateOpen(!isElectorateOpen);
                      setIsVisionOpen(false); 
                      setIsCampaignsOpen(false);
                      setOpenRegion(null); 
                      setOpenAuthority(null);
                    }} 
                    className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${isOpen ? 'justify-between' : 'justify-center'} ${
                      (activeView === 'voterArchetype' || activeView === 'demographics') ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <Vote size={18} />
                      {isOpen && <span className="flex-1 text-left">Electorate</span>}
                    </div>
                    {isOpen && (isElectorateOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />)}
                  </button>
                  {!isOpen && (
                    <div className="absolute left-full top-0 ml-2 z-50 hidden group-hover/electorate:flex flex-col min-w-[160px] bg-slate-800 border border-slate-700 rounded-lg shadow-xl py-1 pointer-events-auto">
                      <div className="px-3 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wider border-b border-slate-700">Electorate</div>
                      <button onClick={() => handleSubNavigation('voterArchetype')} className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-700 ${activeView==='voterArchetype'?'text-white':'text-slate-300'}`}>Archetypes</button>
                      <button onClick={() => handleSubNavigation('demographics')} className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-700 ${activeView==='demographics'?'text-white':'text-slate-300'}`}>Demographics</button>
                    </div>
                  )}
                </div>
                {isOpen && isElectorateOpen && (
                  <div className="pl-7 space-y-1 mt-1">
                    <button onClick={() => handleSubNavigation('voterArchetype')} className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${activeView === 'voterArchetype' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}>
                      <span className="flex-1 text-left">Archetypes</span>
                    </button>
                    <button onClick={() => handleSubNavigation('demographics')} className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${activeView === 'demographics' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}>
                      <span className="flex-1 text-left">Demographics</span>
                    </button>
                  </div>
                )}

                <button onClick={() => handleMainNavigation('candidateViewer')} className={getNavClasses('candidateViewer')}>
                  <Users size={18} />
                  {isOpen && <span className="flex-1 text-left">Candidate</span>}
                </button>
                <button onClick={() => handleMainNavigation('campaignMap')} className={getNavClasses('campaignMap')}>
                  <Map size={18} />
                  {isOpen && <span className="flex-1 text-left">Campaign Map</span>}
                </button>
                <button onClick={() => handleMainNavigation('localIssues')} className={getNavClasses('localIssues')}>
                  <Megaphone size={18} />
                  {isOpen && <span className="flex-1 text-left">Local Issues</span>}
                </button>
                
                {/* Vision Dropdown — with collapsed popout */}
                <div className="relative group/vision">
                  <button 
                    onClick={() => {
                      if (!isOpen) { handleSubNavigation('davinci'); return; }
                      setIsVisionOpen(!isVisionOpen);
                      setIsCampaignsOpen(false); 
                      setIsElectorateOpen(false);
                      setOpenRegion(null); 
                      setOpenAuthority(null);
                    }} 
                    className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${isOpen ? 'justify-between' : 'justify-center'} ${
                      (activeView === 'davinci' || activeView === 'gallery') ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <Sparkles size={18} />
                      {isOpen && <span className="flex-1 text-left">Vision</span>}
                    </div>
                    {isOpen && (isVisionOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />)}
                  </button>
                  {!isOpen && (
                    <div className="absolute left-full top-0 ml-2 z-50 hidden group-hover/vision:flex flex-col min-w-[160px] bg-slate-800 border border-slate-700 rounded-lg shadow-xl py-1 pointer-events-auto">
                      <div className="px-3 py-1.5 text-xs font-bold text-slate-400 uppercase tracking-wider border-b border-slate-700">Vision</div>
                      <button onClick={() => handleSubNavigation('davinci')} className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-700 ${activeView==='davinci'?'text-white':'text-slate-300'}`}>Image Strategy</button>
                      <button onClick={() => handleSubNavigation('gallery')} className={`w-full text-left px-3 py-2 text-sm hover:bg-slate-700 ${activeView==='gallery'?'text-white':'text-slate-300'}`}>Gallery</button>
                    </div>
                  )}
                </div>
                {isOpen && isVisionOpen && (
                  <div className="pl-7 space-y-1 mt-1">
                    <button onClick={() => handleSubNavigation('davinci')} className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${activeView === 'davinci' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}>
                      <span className="flex-1 text-left">Image Strategy</span>
                    </button>
                    <button onClick={() => handleSubNavigation('gallery')} className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${activeView === 'gallery' ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}>
                      <span className="flex-1 text-left">Gallery</span>
                    </button>
                  </div>
                )}
              </div>
            </div>

            {isOpen && (
              <div className="pt-4">
                <div className="text-xs uppercase tracking-wider text-slate-500 mb-2 px-3">Ward Analytics</div>
                <div className="px-2 relative mb-2">
                  <input type="text" placeholder="Search any ward..." value={wardQuery} onChange={(e) => setWardQuery(e.target.value)} className="w-full px-3 pl-8 py-1.5 rounded-md bg-slate-800/50 text-white text-sm placeholder-slate-500 focus:outline-none focus:ring-1 focus:ring-accent-500" />
                  <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500" />
                </div>
                
                {wardQuery ? (
                  <div className="space-y-1">
                    {filteredWards.slice(0, 100).map(ward => (
                      <button key={`${ward.region}-${ward.authority}-${ward.name}`} onClick={() => handleSearchedWardClick(ward)} className={`w-full text-left px-3 py-1.5 text-sm rounded-md transition-colors truncate ${selectedWard && selectedWard.ward_name === ward.name ? 'bg-accent-600 text-white' : 'text-slate-400 hover:bg-slate-700/50'}`}>
                        <p className="font-medium">{ward.name}</p>
                        <p className="text-xs text-slate-500">{ward.authority}, {ward.region}</p>
                      </button>
                    ))}
                    {filteredWards.length === 0 && <p className="px-3 py-2 text-sm text-slate-500">No wards found.</p>}
                  </div>
                ) : (
                  <div className="space-y-1">
                    {Object.keys((campaignData?.wards ?? {})).map(region => (
                      <div key={region}>
                        <button onClick={() => {
                            setOpenRegion(openRegion === region ? null : region);
                            setIsVisionOpen(false); 
                            setIsCampaignsOpen(false); 
                            setIsElectorateOpen(false);
                          }} 
                          className={`flex items-center justify-between w-full px-3 py-2 text-sm rounded-md transition-colors ${openRegion === region ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}
                        >
                          {region}
                          {openRegion === region ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                        </button>
                        {openRegion === region && (
                          <div className="pl-4 mt-1 space-y-1">
                            {Object.keys((campaignData.wards ?? [])[region]).map(authority => (
                              <div key={authority}>
                                <button onClick={() => {
                                    setOpenAuthority(openAuthority === authority ? null : authority);
                                    setIsVisionOpen(false); 
                                    setIsCampaignsOpen(false);
                                    setIsElectorateOpen(false);
                                  }} 
                                  className={`flex items-center justify-between w-full px-3 py-2 text-sm rounded-md transition-colors ${openAuthority === authority ? 'bg-slate-800 text-white' : 'text-slate-300 hover:bg-slate-800/50'}`}
                                >
                                  {authority}
                                  {openAuthority === authority ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                                </button>
                                {openAuthority === authority && (
                                  <div className="pl-4 mt-1 space-y-1 max-h-60 overflow-y-auto">
                                    {Object.keys((campaignData.wards ?? [])[region][authority]).sort().map(wardName => (
                                      <button key={wardName} onClick={() => handleWardClick(region, authority, wardName)} className={`w-full text-left px-3 py-1.5 text-sm rounded-md transition-colors truncate ${selectedWard && selectedWard.ward_name === wardName ? 'bg-accent-600 text-white' : 'text-slate-400 hover:bg-slate-700/50'}`}>
                                        {wardName}
                                      </button>
                                    ))}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </nav>
        </div>
        
        {/* Footer Section (Fixed) - FIXED */}
        <div className="p-2 border-t border-slate-800 shrink-0 mt-auto">
           <button
             onClick={() => onNavigate('settings')}
             className={`w-full flex items-center p-2 rounded-md transition-colors hover:bg-slate-800/50 group ${isOpen ? 'space-x-3' : 'justify-center'}`}
           >
            <div className="flex-shrink-0 w-18 h-18 rounded-lg flex items-center justify-center group-hover:drop-shadow-[0_0_10px_rgba(203,213,225,0.6)] transition duration-300" title={userParty}> 
              <img src={currentPartyLogo} alt={userParty} className="w-full h-full object-cover rounded-lg" />
            </div>
            {isOpen && (
              <div className="overflow-hidden text-left">
                <p className="text-sm font-semibold text-white truncate">{userFullName}</p> 
                <p className="text-xs text-slate-400">{userParty}</p> 
                <p className="text-xs text-slate-500 truncate">{userEmail}</p> 
              </div>
            )}
          </button>
        </div>
      </div>
    </aside>
  );
};

// ====================================================================================
// Main Application Component
// ====================================================================================

const KnoesisDashboard = () => {
  const [activeView, setActiveView] = useState('overview'); 
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedAuthority, setSelectedAuthority] = useState(null);
  const [selectedWard, setSelectedWard] = useState(null);
  const [drawerData, setDrawerData] = useState({ isOpen: false, type: null, data: null });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [vw, setVw] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  // Track viewport width for mobile overlay behaviour
  useEffect(() => {
    const sync = () => setVw(window.innerWidth);
    window.addEventListener('resize', sync);
    window.addEventListener('orientationchange', () => setTimeout(sync, 150));
    return () => window.removeEventListener('resize', sync);
  }, []);

  // isMobileNav: phone — sidebar overlays content and hides fully when closed
  const isMobileNav = vw < 768;

  const {user, setUser} = useAuthUser();
  
  // STATE FOR FETCHED DATA
  const [userData, setUserData] = useState(null);
  const [campaignData, setCampaignData] = useState(null);
  const [isLoading, setIsLoading] = useState(true); 
  // NEW STATE: Tracks if the very first load has finished
  const [hasInitialLoadCompleted, setHasInitialLoadCompleted] = useState(false);

  const [timeGreeting, setTimeGreeting] = useState(getTimeOfDayGreeting());
  
  // === NEW: MULTI-CAMPAIGN STATE ===
  const [availableCampaigns, setAvailableCampaigns] = useState([]);
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);

  // GLOBAL SEARCH STATE
  const [globalSearchQuery, setGlobalSearchQuery] = useState('');
  const searchInputRef = useRef(null);
  const searchContainerRef = useRef(null);
  
  // MAIN CONTENT REF
  const mainContentRef = useRef(null);

  // SYNC PROGRESS STATE
  const [syncState, setSyncState] = useState({ status: 'idle', progress: 0 });
  
  // AUTO LOGOUT STATE AND REF
  const logoutTimerRef = useRef(null);
  const [isInactive, setIsInactive] = useState(false);

  // Usage Time Clock
  const time = useMemo(() => getUsage(),[]);

  // Dwell Visits/Times
  const dwell = useMemo(() => getDwellTime(),[]);

  // Checking for redirect link for forgot password
  const url = new URL(window.location.href);
  const reset = url.searchParams.has("reset","true") && url.searchParams.has("mode","resetPassword");
  const code = url.searchParams.get("oobCode");
  const resetComplete = url.searchParams.has("password");

  // ============================================================================
  // FIX: RESPONSIVE SIDEBAR LOGIC
  // This listener auto-collapses the sidebar on screens smaller than 768px (MD)
  // to ensure scalability across different screen sizes.
  // ============================================================================
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };
    
    // Set initial state based on current window size
    handleResize();
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // You can also reset activeView if you want them to land on 'overview' every time 
    // setActiveView('overview');
    if (reset || resetComplete) {
      return;
    }
    if (!user?.uid) {
      console.hidden("User logged out - resetting dashboard state");
      signOut(auth);
      
      // ============================================================================
      // FIX: CLEAR URL ON LOGOUT TO PREVENT STUCK STATES
      // ============================================================================
      window.history.replaceState(null, '', window.location.pathname);
      
      setHasInitialLoadCompleted(false);
      setSelectedCampaignId(null);
      setCampaignData(null);
      setUserData(null);
      setAvailableCampaigns([]);
    }
  }, [user?.uid, reset]);

  // Update greeting every minute
  useEffect(() => {
    const timer = setInterval(() => setTimeGreeting(getTimeOfDayGreeting()), 60000);
    return () => clearInterval(timer);
  }, []);

  // ----------------------------------------------------------------------------------
  // CONCURRENT SESSION HANDLING (Single User Policy)
  // ----------------------------------------------------------------------------------
  useEffect(() => {
    if (!user?.uid) return;
    // Generate a unique Session ID for *this* browser tab/instance
    const thisSessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const userSessionRef = doc(db, 'users', user?.uid, "sessions", "active_session");

    // 1. Claim the session immediately upon mount/login
    setDoc(userSessionRef, { 
      currentSessionId: thisSessionId, 
      lastActive: new Date(),
      deviceInfo: navigator.userAgent 
    }, { merge: true })
      .then(() => console.hidden(`Session claimed: ${thisSessionId}`))
      .catch(err => console.error("Error claiming session:", err));

    // 2. Listen for changes to the active session ID in Firestore
    const unsubscribe = onSnapshot(userSessionRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        
        // If the database has a sessionId, and it is NOT equal to our local sessionId,
        // it means another device has logged in and claimed the session.
        if (data.currentSessionId && data.currentSessionId !== thisSessionId) {
           console.warn("Concurrent session detected. Another device logged in. Signing out.");
           // Immediately sign out the user
           isSignedIn(false).then(() => auth.signOut().then(() => setUser(undefined)));
        }
      }
    }, (error) => {
       console.error("Session listener error:", error);
    });

    return () => unsubscribe();
  }, [user?.uid]);


  // ----------------------------------------------------------------------------------
  // AUTO LOGOUT LOGIC (10 Minutes Inactivity)
  // ----------------------------------------------------------------------------------
  const resetLogoutTimer = useCallback(() => {
    if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    
    // Set timer for 10 minutes (600,000 milliseconds)
    logoutTimerRef.current = setTimeout(() => {
      console.hidden("User inactive for 10 minutes. Showing inactivity screen.");
      setIsInactive(true); // Changed from direct signout to state update
    }, 10 * 60 * 1000);
  }, []); 

  useEffect(() => {
    if (!user?.uid) return;

    // Events that are considered "Activity"
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    
    // Throttle mechanism to prevent resetting timer on every single mouse pixel movement
    let lastResetTimestamp = 0;
    
    const handleActivity = () => {
      const now = Date.now();
      // Only reset timer if more than 1 second has passed since last reset
      // This drastically reduces CPU overhead for mousemove events
      if (now - lastResetTimestamp > 1000) {
        resetLogoutTimer();
        lastResetTimestamp = now;
      }
    };

    // Attach listeners
    events.forEach(event => window.addEventListener(event, handleActivity));
    
    // Initialize timer immediately on mount
    resetLogoutTimer();

    // Cleanup listeners and timer on unmount or logout
    return () => {
      if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
      events.forEach(event => window.removeEventListener(event, handleActivity));
    };
  }, [user?.uid, resetLogoutTimer]);

  const handleInactivitySignOut = () => {
    // ============================================================================
    // FIX: CLEAR URL ON TIMEOUT TO PREVENT RELOADING INTO STALE VIEW
    // ============================================================================
    window.history.replaceState(null, '', window.location.pathname);
    
    setIsInactive(false);
    setActiveView('overview'); // Ensure state is reset
    isSignedIn(false);
    time.stopClock(selectedCampaignId);
    isSignedIn(false).then(() => auth.signOut().then(() => setUser(undefined)));
  };

  // 👇 UPDATED BEFOREUNLOAD BLOCK 👇
  useEffect(() => {
    const handleBeforeUnload = () => {
      if (selectedCampaignId) {
        time.stopClock(selectedCampaignId);
        dwell.logTime(selectedCampaignId, activeView);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [selectedCampaignId, activeView, time, dwell]);


  // ----------------------------------------------------------------------------------
  // HISTORY & NAVIGATION HANDLING
  // ----------------------------------------------------------------------------------

  // 1. Centralized Navigation Handler
  const handleNavigation = useCallback((view, wardData = null) => {
    setActiveView(view);
    setSelectedWard(wardData);
    
    if (wardData) {
      setSelectedRegion(wardData.region);
      setSelectedAuthority(wardData.authority);
    }

    const url = new URL(window.location);
    
    // Convert Internal ID -> Pretty URL String (or fallback to ID)
    const publicViewName = URL_MAPPING[view] || view; 
    url.searchParams.set('view', publicViewName);

    // If navigating to a ward, add params
    if (wardData && view === 'ward_overview') {
      url.searchParams.set('ward', wardData.ward_name);
      url.searchParams.set('authority', wardData.authority);
      url.searchParams.set('region', wardData.region);
    } else {
      url.searchParams.delete('ward');
      url.searchParams.delete('authority');
      url.searchParams.delete('region');
    }

    // Push to browser history
    window.history.pushState({ view, ward: wardData }, '', url);

    if (selectedCampaignId) {
      // 1. Stop the clock for the view the user is LEAVING
      dwell.logTime(selectedCampaignId, activeView);
      
      // 2. Start the clock for the NEW view the user is ENTERING
      dwell.logVisit(selectedCampaignId, view);
    }

  }, [selectedCampaignId, activeView, dwell]);

  // 2. Handle Browser Back/Forward Buttons
  useEffect(() => {
    const handlePopState = (event) => {
      // log visit even if going back
    selectedCampaignId && dwell.logVisit(selectedCampaignId,view);
      const state = event.state;
      if (state) {
        setActiveView(state.view || 'overview');
        setSelectedWard(state.ward || null);
        if (state.ward) {
            setSelectedRegion(state.ward.region);
            setSelectedAuthority(state.ward.authority);
        }
      } else {
        setActiveView('overview');
        setSelectedWard(null);
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // 3. Handle Initial Load / Refresh with URL Params
  useEffect(() => {
    if (!campaignData) return;

    const params = new URLSearchParams(window.location.search);
    const viewParam = params.get('view');
    
    // Find internal View ID from Pretty URL String
    const internalView = Object.keys(URL_MAPPING).find(key => URL_MAPPING[key] === viewParam) || viewParam;

    const wardParam = params.get('ward');
    const authParam = params.get('authority');
    const regionParam = params.get('region');

    if (internalView) {
      setActiveView(internalView);
      
      if (internalView === 'ward_overview' && wardParam && authParam && regionParam) {
        try {
            const wardInfo = campaignData.wards[regionParam][authParam][wardParam];
            if (wardInfo) {
                const narrative = campaignData.narratives?.find(n => n.ward_id === wardInfo.ward_code)?.narrative;
                const demographic_variants = campaignData?.demographicVariants.find((demographics) => demographics.ward_code === wardInfo.ward_code)
                const fullWardData = { ...wardInfo, narrative, demographic_variants };
                setSelectedWard(fullWardData);
                setSelectedRegion(regionParam);
                setSelectedAuthority(authParam);
            }
        } catch (e) {
            console.warn("Could not load ward from URL params", e);
        }
      }
    }
  }, [campaignData]);

  // 4. Scroll to Top on View Change (WINDOW and CONTAINER)
  useEffect(() => {
    // Scroll the window to the top (covers standard scrolling)
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' 
    });

    // Also try scrolling the main container if it has its own overflow
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [activeView, selectedWard]);


  // DYNAMIC VARIABLES
  const userFirstName = userData?.firstName || 'User'; 
  const userFullName = userData ? `${userData.firstName} ${userData.lastName}` : 'Knoesis User';
  const userParty = userData?.party || 'Independent';
  const userEmail = user?.email || userData?.email || 'N/A'; 
  
  // FIX: Look up the Campaign Name directly from available list based on ID
  // This ensures we always show the name instead of falling back to the default string ID
  const displayCampaignName = useMemo(() => {
    const activeCamp = availableCampaigns.find(c => c.campaignID === selectedCampaignId);
    return activeCamp?.campaignName || campaignData?.campaignName || 'No Active Campaign';
  }, [selectedCampaignId, availableCampaigns, campaignData]);
  
  // ====================================================================================
  // DATA FETCHING STRATEGY
  // 1. Fetch User (Determine Available Campaigns)
  // 2. Fetch Campaign Data (Based on Selected ID)
  // ====================================================================================
  
  // EFFECT 1: INITIAL USER AUTH & CAMPAIGN DISCOVERY
  useEffect(() => {
    if (!auth.currentUser?.uid) {
      setUserData(null);
      setCampaignData(null);
      setIsLoading(false);
      return;
    }

    const fetchUser = async () => {
      setIsLoading(true);
      try {
        const response = (await fetch("https://us-central1-knoesis-dante.cloudfunctions.net/getUser?uid=" + auth.currentUser.uid)).json();
        const campaignTenants = (await fetch("https://us-central1-knoesis-dante.cloudfunctions.net/getCampaignTenants?userID=" + auth.currentUser.uid)).json();
        console.hidden("FULL USER RESPONSE:", response); // <--- Add this
        console.hidden("AVAILABLE CAMPAIGNS:", campaignTenants); // <--- Add this
        
        const { user: userProfile, campaign: defaultCampaign } = response;
        
        setUserData(userProfile);
        setAvailableCampaigns(campaignTenants);

        // LOGIC: Determine available campaigns
        // If the backend returns a list (future proof), use it.
        // If not, construct a list of one from the single campaign object returned.
        let campaigns = [];
        
        if (campaignTenants && campaignTenants.length > 0) {
             campaigns = campaignTenants;
        } else if (defaultCampaign) {
             campaigns = [{ id: defaultCampaign.campaignID, name: defaultCampaign.campaignName }];
        }

        // If last viewed campaign isn't equal to the first, then last viewed has changed, apply it 
        if (defaultCampaign.campaignID != campaigns[0].campaignID) {
          setSelectedCampaignId(defaultCampaign.campaignID);
        }
        // Set the default selection (First one) if not already set
        else if (campaigns.length > 0 && !selectedCampaignId) {
            setSelectedCampaignId(campaigns[0].campaignID);
        } else if (campaigns.length === 0) {
            // Handle edge case of no campaigns
            setIsLoading(false);
        }

      } catch (error) {
        console.error("Error fetching user profile:", error);
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [auth.currentUser]); 

// System Message Fetching etc.
  const [messages, setMessages] = useState([]);
  useMemo(() => getDocs(collection(db,"meta/toolbox/system_messages")).then((messages) => {
    setMessages(messages.docs.filter((doc) => {
      return doc.data().status === "active"
    }).map((doc) => {
      return {...doc.data(), docId: doc.id}
    })
  );
  }),[]);



  // EFFECT 2: CAMPAIGN SPECIFIC DATA FETCHING (Triggers on selectedCampaignId change)
  useEffect(() => {
    if (!selectedCampaignId || !auth.currentUser) return;

    // ============================================================================
    // FIX: IMMEDIATE RESET TO OVERVIEW ON CAMPAIGN SWITCH
    // This prevents the app from trying to render old wards/views with new campaign data
    // ============================================================================
    setActiveView('overview');
    setSelectedWard(null);
    window.history.replaceState(null, '', window.location.pathname); // Clear URL params

    const fetchCampaignSpecifics = async () => {
      log(selectedCampaignId,"signedInUsers",auth.currentUser.uid,1);
      setIsLoading(true);
      const {success} = await (await fetch(`https://us-central1-knoesis-dante.cloudfunctions.net/switchLastViewedCampaign?userID=${auth.currentUser.uid}&campaignID=` + selectedCampaignId)).json();
      console.hidden(`Switching to Campaign ID: ${selectedCampaignId}; ${success}`);

      try {
        // Fetch all heavy data for this specific campaign ID
        const wards = await (await fetch("https://us-central1-knoesis-dante.cloudfunctions.net/getCampaignWards?campaignID=" + selectedCampaignId)).json();
        const wardDemographicVariants = await (await fetch("https://us-central1-knoesis-dante.cloudfunctions.net/getCampaignWardDemographicVariants?campaignID=" + selectedCampaignId)).json();
        const candidate_data = await (await fetch(`https://us-central1-knoesis-dante.cloudfunctions.net/getCampaignCandidateProfile?campaignID=${selectedCampaignId}`)).json();
        const swingSuggestions = await (await fetch(`https://us-central1-knoesis-dante.cloudfunctions.net/getCampaignSwingSuggestions?campaignID=${selectedCampaignId}`)).json();
        const narratives = await (await fetch(`https://us-central1-knoesis-dante.cloudfunctions.net/getCampaignNarratives?campaignID=${selectedCampaignId}`)).json();
        const campaignDetailsRes = await fetch(`https://us-central1-knoesis-dante.cloudfunctions.net/getCampaignOverview?campaignID=${selectedCampaignId}`); 
        
        if (!campaignDetailsRes.ok) throw new Error(`Failed to fetch campaign details (${campaignDetailsRes.status})`);
        const campaignDetailsJson = await campaignDetailsRes.json();
        
        // Find name from available list or default
        const currentCampName = availableCampaigns.find((campaign) => campaign.campaignID === selectedCampaignId).campaignName || userData?.campaign?.campaignName;

        // Optimistic Sync (Fire and Forget) --- Not using this while it doesn't work since it's costing RAG API time/money
        // setSyncState({ status: 'syncing', progress: 5 });
        // window.fetch("https://dante-rag-api-84264019333.europe-west1.run.app/sync-campaign", {
        //   "headers": {
        //     "authorization": "Bearer " + (await auth.currentUser.getIdTokenResult()).token,
        //     "content-type": "application/json"
        //   },
        //   "body": JSON.stringify({ "campaign_id": selectedCampaignId }),
        //   "method": "POST"
        // })
        // .then(res => {
        //     if (!res.ok) throw new Error("Sync failed");
        //     return res.json();
        // })
        // .then(data => {
        //     console.hidden("Sync completed successfully:", data);
        //     setSyncState({ status: 'completed', progress: 100 });
        // })
        // .catch(err => {
        //     console.error("Sync failed or timed out", err);
        //     setSyncState({ status: 'idle', progress: 0 });
        // });

        // UPDATE MAIN STATE
        setCampaignData({
            campaignID: selectedCampaignId,
            campaignName: currentCampName,
            wards: wards,
            candidate_data: candidate_data,
            swingSuggestions: swingSuggestions.map((swing) => ({ ward: swing.ward_name, ...swing })),
            narratives: narratives,
            overview: {
            ...campaignDetailsJson,
            profile: candidate_data?.minerva_analysis,
            campaignName: currentCampName
            },
            demographicVariants: wardDemographicVariants,
        });
        time.startClock();
        
        // MARK INITIAL LOAD AS COMPLETE
        setHasInitialLoadCompleted(true);

      } catch (error) {
          console.error("Error loading campaign data:", error);
      } finally {
          setIsLoading(false);
      }
    };

    fetchCampaignSpecifics();
    return () => {
        time.stopClock(selectedCampaignId);
        // Removed dwell.logTime here to prevent the reload loop
    };
  }, [selectedCampaignId]);

  // Sync Simulation Effect
  useEffect(() => {
    let interval;
    if (syncState.status === 'syncing') {
        interval = setInterval(() => {
            setSyncState(prev => {
                if (prev.progress >= 95) return prev; 
                return { ...prev, progress: prev.progress + 0.5 };
            });
        }, 300);
    }
    return () => clearInterval(interval);
  }, [syncState.status]);

  
  const navigateToChatbot = () => {
    handleNavigation('chatbot');
  };

  const navigationItems = useMemo(() => [
    { type: 'navigation', id: 'nav-overview', name: 'Overview', view: 'overview' },
    { type: 'navigation', id: 'nav-plato', name: 'Campaign Matrix', view: 'plato' }, 
    { type: 'navigation', id: 'nav-campaignGallery', name: 'Saved Campaigns', view: 'campaignGallery' },
    { type: 'navigation', id: 'nav-simCalendar', name: 'Simulation Calendar', view: 'simCalendar' }, 
    { type: 'navigation', id: 'nav-opponentViewer', name: 'Opponents', view: 'opponentViewer' },
    { type: 'navigation', id: 'nav-voterArchetype', name: 'Archetypes (Electorate)', view: 'voterArchetype' },
    { type: 'navigation', id: 'nav-demographics', name: 'Demographics (Electorate)', view: 'demographics' }, // ADDED TO SEARCH
    { type: 'navigation', id: 'nav-candidateViewer', name: 'Candidates', view: 'candidateViewer' },
    { type: 'navigation', id: 'nav-campaignMap', name: 'Campaign Map', view: 'campaignMap' },
    { type: 'navigation', id: 'nav-localIssues', name: 'Local Issues Portal', view: 'localIssues' }, 
    { type: 'navigation', id: 'nav-davinci', name: 'Vision', view: 'davinci' },
    { type: 'navigation', id: 'nav-chatbot', name: 'Dante Chatbot', action: 'navigate_chatbot' }, 
    { type: 'navigation', id: 'nav-settings', name: 'Settings', view: 'settings' },
  ], []);
  
  const allSearchableItems = useMemo(() => {
    const wardItems = Object.entries((campaignData?.wards ?? {})).flatMap(([region, authorities]) =>
      Object.entries(authorities).flatMap(([authority, wards]) =>
        Object.keys(wards).map(wardName => ({
          type: 'ward',
          id: `${region}-${authority}-${wardName}`,
          name: wardName,
          authority,
          region,
          view: 'ward_overview',
          data: {
            ...campaignData.wards[region][authority][wardName],
            // FIX 1: Added ?. to 'n' just in case
            narrative: campaignData?.narratives?.find(n => n?.ward_id === campaignData.wards[region][authority][wardName]?.ward_code)?.narrative ?? null,
            // FIX 2: Added ?. to 'demographics' to handle null entries in the array
            demographic_variants: campaignData?.demographicVariants?.find((demographics) => demographics?.ward_code === campaignData.wards[region][authority][wardName]?.ward_code),
          },
        }))
      )
    );
    return [...navigationItems, ...wardItems];
  }, [navigationItems, campaignData?.campaignID, campaignData?.wards, campaignData?.narratives]);

  const globalFilteredResults = useMemo(() => {
    if (!globalSearchQuery) return [];
    
    const escapedQuery = globalSearchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`^${escapedQuery}`, 'i');
    
    const navigation = allSearchableItems.filter(item =>
        item.type === 'navigation' && regex.test(item.name)
    );

    const wards = allSearchableItems.filter(item =>
      item.type === 'ward' && (
        regex.test(item.name) || regex.test(item.authority) || regex.test(item.region)
      )
    );
    
    return [
      { type: 'Navigation Views', results: navigation },
      { type: 'Ward Analytics', results: wards.slice(0, 10) },
    ].filter(group => group.results.length > 0);
  }, [globalSearchQuery, allSearchableItems]);

  const handleGlobalSearchResultClick = (item) => {
    if (item.type === 'ward') {
      handleNavigation(item.view, item.data);
    } else if (item.type === 'navigation') {
      if (item.action === 'navigate_chatbot') {
        navigateToChatbot();
      } else {
        handleNavigation(item.view);
      }
    }
    setGlobalSearchQuery('');
  };
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setGlobalSearchQuery('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const closeDrawer = () => setDrawerData({ isOpen: false, type: null, data: null });

  // 1. HANDLE NOT LOGGED IN
  if (!user?.uid) {
     return <SignInPage setUser={setUser} reset={{reset: reset || resetComplete, code}}></SignInPage>;
  }

  if (isLoading && hasInitialLoadCompleted) {
    return (
        <div className="relative flex flex-col items-center justify-center h-screen w-full bg-slate-950 text-white overflow-hidden">
            <div className="flex flex-col items-center justify-center z-10 animate-in fade-in zoom-in duration-500 max-w-2xl w-full px-6">
                <div className="mb-6 md:mb-8 transition-all duration-300">
                  <img 
                    src={danteWhiteFull} 
                    className="h-16 sm:h-20 md:h-24 w-auto object-contain drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" 
                    alt="Dante Logo" 
                  />
                </div>
              <div className="text-center w-full">
                  <h2 className="text-sm md:text-base text-slate-500 font-medium mb-1">
                      Initialising
                  </h2>
                  <h1 className="text-xl sm:text-2xl md:text-3xl text-white font-semibold tracking-wide drop-shadow-[0_0_15px_rgba(255,255,255,0.15)]">
                      {displayCampaignName}
                  </h1>
                  <p className="text-[10px] md:text-xs text-slate-600 mt-4 uppercase tracking-[0.2em]">
                      Please Wait
                  </p>
              </div>
                <div className="mt-6 md:mt-8">
                    <span className="loader scale-100 md:scale-125 transition-transform duration-300"></span>
                </div>
            </div>
            <div className="absolute bottom-6 md:bottom-8 w-full text-center space-y-2 md:space-y-3 px-6 font-sans">
                <p className="text-[8px] md:text-[10px] uppercase tracking-[0.2em] text-white opacity-90">
                    Dante is a probabilistic engine, all results should be cross referenced prior to execution
                </p>
                <p className="text-[8px] md:text-[10px] text-white opacity-70">
                    &copy; Knoesis Technologies 2026
                </p>
            </div>
        </div>
    );
  }

  if (isLoading) { 
    return (
        <div className="relative flex flex-col items-center justify-center h-screen w-full bg-slate-950 text-white overflow-hidden">
            <div className="flex flex-col items-center justify-center z-10 animate-in fade-in zoom-in duration-500 w-full px-6">
                <div className="mb-6 md:mb-8 transition-all duration-300">
                  <img 
                    src={danteWhiteFull} 
                    className="h-16 sm:h-20 md:h-24 w-auto object-contain drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" 
                    alt="Dante Logo" 
                  />
                </div>
                <div className="min-h-[4rem] md:min-h-[5rem] flex items-center justify-center w-full max-w-4xl">
                  <h2 className="text-base sm:text-lg md:text-xl lg:text-2xl text-center leading-relaxed">
                      {!userData ? (
                         <span className="animate-pulse text-slate-500 font-grotesk">_</span>
                      ) : (
                         <TypingEffect 
                            text={`${timeGreeting} ${userData.firstName}, we are just getting your data ready.`} 
                            speed={80} 
                         />
                      )}
                  </h2>
                </div>
                <div className="mt-6 md:mt-8">
                    <span className="loader scale-100 md:scale-125 transition-transform duration-300"></span>
                </div>
            </div>
            <div className="absolute bottom-6 md:bottom-8 w-full text-center space-y-2 md:space-y-3 px-6 font-sans">
                <p className="text-[8px] md:text-[10px] uppercase tracking-[0.2em] text-white opacity-90">
                    Dante is a probabilistic engine, all results should be cross referenced prior to execution
                </p>
                <p className="text-[8px] md:text-[10px] text-white opacity-70">
                    &copy; Knoesis Technologies 2026
                </p>
            </div>
        </div>
    ); 
  }

  // 3. HANDLE INITIAL LOAD (Logged In + Loading + FIRST LOAD)
  if (isLoading) { 
    return (
        <div className="relative flex flex-col items-center justify-center h-screen w-full bg-slate-950 text-white overflow-hidden">
            {/* Centered Content */}
            <div className="flex flex-col items-center justify-center z-10 animate-in fade-in zoom-in duration-500 w-full px-4">
                
                {/* Logo Section */}
                <div className="mb-8">
                  <img 
                    src={danteWhiteFull} 
                    className="h-24 w-auto object-contain drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" 
                    alt="Dante Logo" 
                  />
                </div>

                {/* Dynamic Typing Greeting */}
                {/* Added 'whitespace-nowrap' to force single line */}
                {/* Added responsive text sizes (text-lg -> text-2xl) to ensure it fits on screen */}
                <div className="h-16 flex items-center justify-center w-full max-w-4xl">
                  <h2 className="text-lg md:text-xl lg:text-2xl text-center whitespace-nowrap min-h-[2rem]">
                      {!userData ? (
                         /* Wait state - Blinking Cursor */
                         <span className="animate-pulse text-slate-500 font-grotesk">_</span>
                      ) : (
                         /* Data arrived - Type it out */
                         <TypingEffect 
                            text={`${timeGreeting} ${userData.firstName}, we are just getting your data ready.`} 
                            speed={80} 
                         />
                      )}
                  </h2>
                </div>

                {/* Spinner */}
                <div className="mt-8">
                    <span className="loader scale-125"></span>
                </div>
            </div>

            {/* Footer Disclaimer */}
            <div className="absolute bottom-8 w-full text-center space-y-3 px-4 font-sans">
                <p className="text-[10px] uppercase tracking-[0.2em] text-white opacity-90">
                    Dante is a probabilistic engine, all results should be cross referenced prior to execution
                </p>
                <p className="text-[10px] text-white opacity-70">
                    &copy; Knoesis Technologies 2026
                </p>
            </div>
        </div>
    ); 
  }

  const onAcknowledge = (message) => {
    setDoc(doc(db,"meta/toolbox/system_messages/" + message.docId),{
      users: [...(message.users ? message.users : []), user.uid]
    },{merge: true}).then(() => setMessages((prev) => prev.filter((list) => list.id !== message.id)))
  }

  return (
    <div className="bg-slate-950 text-slate-300 font-sans antialiased min-h-screen">
      <header className="bg-slate-900/60 backdrop-blur-sm sticky top-0 z-40 border-b border-slate-700 h-16 flex items-center justify-between px-4 md:px-6">
        <div className="flex items-center space-x-3">
          {/* Mobile hamburger in header */}
          {isMobileNav && (
            <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="p-2 rounded-md text-slate-400 hover:bg-slate-800 flex-shrink-0">
              <Menu size={20} />
            </button>
          )}
          
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-4 focus:outline-none group select-none transition-all duration-300 hover:drop-shadow-[0_0_10px_rgba(203,213,225,0.6)] cursor-pointer">
              <img src={logo} className="w-8 h-8 flex-shrink-0 group-hover:scale-110 transition-transform duration-200" alt="Knoesis Logo"></img>
              <div className="flex items-center">
                <span className="hidden sm:inline text-lg font-bold text-slate-400">Knoesis</span>
                <div className="hidden sm:block w-px h-5 bg-slate-700 mx-3"></div>
                <span className="text-2xl font-bold text-white font-grotesk">Dante</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex-1 max-w-lg mx-2 md:mx-8 relative" ref={searchContainerRef}>
          <input 
            type="text" 
            placeholder="Search campaigns, wards, or channels..." 
            value={globalSearchQuery}
            onChange={(e) => setGlobalSearchQuery(e.target.value)}
            ref={searchInputRef}
            className={`w-full pl-10 pr-4 py-2 rounded-full bg-slate-800/50 border text-white placeholder-slate-500 text-sm focus:outline-none transition-all duration-300
              ${globalSearchQuery 
                  ? 'border-slate-500 shadow-[0_0_15px_rgba(203,213,225,0.5)]' 
                  : 'border-slate-700 focus:border-slate-500 focus:shadow-[0_0_15px_rgba(203,213,225,0.5)]'
              }`} 
          />
          <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
          
          {globalSearchQuery && (
            <div className="absolute top-full mt-2 w-full max-h-96 overflow-y-auto bg-slate-800/95 backdrop-blur-md rounded-lg shadow-2xl border border-slate-700 z-50 p-2">
              {globalFilteredResults.length > 0 ? (
                globalFilteredResults.map(group => (
                  <div key={group.type} className="mb-2 last:mb-0">
                    <div className="text-xs uppercase tracking-wider text-slate-500 px-3 pt-2 pb-1">{group.type}</div>
                    <div className="space-y-1">
                      {group.results.map(item => (
                        <button 
                          key={item.id || item.name} 
                          onClick={() => handleGlobalSearchResultClick(item)}
                          className="w-full text-left px-3 py-1.5 text-sm rounded-md transition-colors hover:bg-slate-700/50 text-slate-200"
                        >
                          <p className="font-medium truncate">{item.name}</p>
                          {item.type === 'ward' && <p className="text-xs text-slate-400">{item.authority}, {item.region}</p>}
                        </button>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <p className="px-3 py-2 text-sm text-slate-500">No results found for "{globalSearchQuery}".</p>
              )}
            </div>
          )}
        </div>

        <nav className="flex items-center space-x-4">
           {/* {syncState.status !== 'idle' && (
              <div className="flex items-center mr-2 space-x-3 bg-slate-800/50 px-3 py-1.5 rounded-full border border-slate-700/50">
                 <span className={`text-[10px] uppercase tracking-wider font-bold ${syncState.status === 'completed' ? 'text-emerald-400' : 'text-slate-400'}`}>
                    {syncState.status === 'completed' ? 'Synced' : 'Syncing'}
                 </span>
                 
                 {syncState.status === 'syncing' && (
                   <div className="flex items-center space-x-2">
                     <div className="w-24 h-1.5 bg-slate-700 rounded-full overflow-hidden">
                        <div
                           className={`h-full transition-all duration-500 ease-out ${
                              syncState.progress < 33 ? 'bg-red-500' :
                              syncState.progress < 66 ? 'bg-orange-500' :
                              'bg-emerald-500'
                           }`}
                           style={{ width: `${syncState.progress}%` }}
                        />
                     </div>
                     <span className="text-[10px] font-mono text-slate-400 w-8 text-right">
                        {Math.round(syncState.progress)}%
                     </span>
                   </div>
                 )}
                 {syncState.status === 'completed' && <CheckCircle2 size={14} className="text-emerald-400" />}
              </div>
           )} */}

          <button 
            className="btn-icon transition duration-300 hover:drop-shadow-[0_0_10px_rgba(203,213,225,0.6)]" 
            onClick={() => handleNavigation('notifications')} 
            title="Inbox">
              <Inbox size={20} />
          </button>
          <button 
            className="btn-icon transition duration-300 hover:drop-shadow-[0_0_10px_rgba(203,213,225,0.6)]" 
            onClick={() => {
              time.stopClock(selectedCampaignId);
              isSignedIn(false).then(() => auth.signOut().then(() => setUser(undefined)));
            }}
            title="Sign Out">
              <LogOut size={20} />
          </button>
        </nav>
      </header>
      
      <div className="flex relative">
        {/* Mobile scrim — tap to close sidebar */}
        {isMobileNav && isSidebarOpen && (
          <div className="fixed inset-0 z-30 bg-slate-950/60 backdrop-blur-sm"
            onClick={() => setIsSidebarOpen(false)}/>
        )}
        <Sidebar 
          isOpen={isSidebarOpen} 
          setIsOpen={setIsSidebarOpen}
          isMobileNav={isMobileNav}
          userFirstName={userFirstName}
          userFullName={userFullName}
          userParty={userParty}
          userEmail={userEmail}
          displayCampaignName={displayCampaignName} 
          timeGreeting={timeGreeting}
          onNavigate={handleNavigation}
          activeView={activeView}
          setActiveView={setActiveView}
          selectedWard={selectedWard}
          setSelectedWard={setSelectedWard}
          campaignData={campaignData}
          availableCampaigns={availableCampaigns}
          currentCampaignId={selectedCampaignId}
          onSwitchCampaign={(newId) => setSelectedCampaignId(newId)}
        />
        <main ref={mainContentRef} className="flex-1 overflow-y-auto transition-all duration-300">
          {activeView === 'overview' && <OverviewPage overviewData={campaignData?.overview} setActiveView={handleNavigation} setDrawerData={setDrawerData} />}
          
          {activeView === 'plato' && <PlatoView wards={campaignData?.wards} swingSeats={campaignData?.swingSuggestions} campaignId={selectedCampaignId} setActiveView={setActiveView} />}
          
          {activeView === 'campaignGallery' && <CampaignGallery campaignId={selectedCampaignId} onStartCampaign={() => setActiveView("plato")} />}
          
          {activeView === 'simCalendar' && <SimCalendar campaignId={selectedCampaignId} setActiveView={handleNavigation} />} 
          
          {/*activeView === 'opponentViewer' && <OpponentViewer />*/}
          {activeView === 'voterArchetype' && <VoterArchetype campaignData={campaignData?.overview} />}
          {activeView === 'demographics' && <DemographicsSuite summaryData={campaignData?.overview.demographicData} campaignData={campaignData?.overview} cohortStaticData={{
            18_24: eighteen,
            25_34: twentyfive,
            35_44: thirtyfive,
            45_54: fortyfive,
            55_64: fiftyfive,
            64_75: sixtyfour,
            "75_plus": seventyfive,
          }} />}
          
          {activeView === 'candidateViewer' && <CandidateViewer data={campaignData?.candidate_data} campaignId={selectedCampaignId} />}
          
          {activeView === 'campaignMap' && <CampaignMap campaign={campaignData}/>}
          
          {activeView === 'localIssues' && <LocalIssuePortal wards={campaignData?.wards} campaignId={selectedCampaignId}/>}
          
          {activeView === 'davinci' && <DavinciView campaignId={selectedCampaignId} allCampaignWards={campaignData?.wards ?? []}/>}
          
          {activeView === 'gallery' && <ImageGallery campaignId={selectedCampaignId} onDavinciClick={() => handleNavigation("davinci")} />}
          
          {activeView === 'ward_overview' && (
            <WardOverview
              selectedWard={selectedWard}
              setDrawerData={setDrawerData}
              candidateProfilerData={campaignData?.candidate_data}
            />
          )}

          {activeView === 'notifications' && <NotificationsPage notifications={messages} />}
          
          {activeView === 'chatbot' && (
          <DanteChatBot campaignId={selectedCampaignId} /> 
          )}
          
          {activeView === 'settings' && <SettingsPage campaignId={selectedCampaignId} />}
        </main>

        {drawerData.isOpen && (
          <div
            className="fixed inset-0 bg-slate-950/50 backdrop-blur-sm z-40 transition-opacity duration-300"
            onClick={closeDrawer}
          ></div>
        )}
        <RightDrawer
          isOpen={drawerData.isOpen}
          onClose={closeDrawer}
          type={drawerData.type}
          data={drawerData.data}
        />

        {messages
        .filter((message) => !message.users?.includes(user.uid))
        .map((message) => <SystemMessageModal key={message.docId || message.id} message={message} onAcknowledge={onAcknowledge}></SystemMessageModal>)}
        
        {/* INACTIVITY OVERLAY */}
        {isInactive && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/50 backdrop-blur-md transition-opacity duration-500 animate-fade-in px-4">
              <div className="bg-slate-900 p-6 md:p-8 rounded-2xl shadow-[0_0_20px_rgba(0,0,0,0.5)] border border-slate-800 text-center max-w-sm md:max-w-md w-full mx-auto">
                <div className="flex justify-center mb-4 md:mb-6">
                   <div className="p-3 md:p-4 rounded-full bg-slate-800/50 border border-slate-700 shadow-inner transition-transform duration-300 hover:scale-105">
                      <Lock className="w-6 h-6 md:w-8 md:h-8 text-slate-300" />
                   </div>
                </div>
                <h2 className="text-lg md:text-xl font-semibold text-white mb-2">Session Timed Out</h2>
                <p className="text-slate-400 text-xs md:text-sm mb-6 md:mb-8 px-2">
                  You have been signed out due to inactivity to protect your session.
                </p>
                <button
                  onClick={handleInactivitySignOut}
                  className="w-full flex justify-center py-2.5 md:py-3 px-4 border border-transparent rounded-lg shadow-sm text-xs md:text-sm font-semibold text-slate-100 
                             bg-slate-700 hover:bg-slate-600 
                             hover:drop-shadow-[0_0_8px_rgba(203,213,225,0.25)] 
                             transition-all duration-300 uppercase tracking-wide active:scale-[0.98]"
                >
                  Click here to sign in
                </button>
              </div>
            </div>
        )}
      </div>
    </div>
  );
};

export default KnoesisDashboard;